import { useNavigate } from "react-router-dom";
import AnimeCard from "@/components/feature/AnimeCard";
import SectionHeader from "@/components/feature/SectionHeader";
import { getByCategory } from "@/mocks/anime";

export function CategoryPreview() {
  const navigate = useNavigate();
  const sections = [
    {
      eyebrow: "宝藏挖掘",
      title: "冷门佳作",
      desc: "评分不低却常被忽略，藏在角落里的宝藏番，挖到就是赚到。",
      linkTo: "/list/hidden",
      linkText: "挖更多冷门",
      items: getByCategory("hidden").slice(0, 4),
      bg: "bg-background-50",
    },
    {
      eyebrow: "一次看个痛快",
      title: "完结番合集",
      desc: "已完结高口碑佳作，不用追更、不用等，随时开刷一路到底。",
      linkTo: "/list/finished",
      linkText: "看完结番",
      items: getByCategory("finished").slice(0, 4),
      bg: "bg-background-100",
    },
  ];

  return (
    <>
      {sections.map((sec) => (
        <section key={sec.title} className={sec.bg}>
          <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
            <SectionHeader
              eyebrow={sec.eyebrow}
              title={sec.title}
              desc={sec.desc}
              linkText={sec.linkText}
              linkTo={sec.linkTo}
            />
            <div className="grid grid-cols-2 gap-4 lg:grid-cols-4 md:gap-5">
              {sec.items.map((anime) => (
                <AnimeCard key={anime.id} anime={anime} />
              ))}
            </div>
            <div className="mt-6 text-center lg:hidden">
              <button
                type="button"
                onClick={() => navigate(sec.linkTo)}
                className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50"
              >
                {sec.linkText}
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </section>
      ))}

      {/* 熬夜补番清单横幅 + 精选 */}
      <section className="relative overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20cozy%20late%20night%20anime%20marathon%20scene%20with%20a%20warm%20glowing%20lamp%2C%20snacks%20and%20popcorn%20on%20a%20blanket%20by%20a%20screen%2C%20moonlit%20city%20out%20the%20window%2C%20warm%20amber%20and%20deep%20burgundy%20palette%2C%20cinematic%20storybook%20illustration&width=1600&height=700&seq=xh-night-01&orientation=landscape"
          alt="熬夜补番清单横幅插画"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/85 via-primary-900/70 to-primary-950/50"></div>
        <div className="relative z-10 mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-foreground-900">
              <i className="ri-moon-fill" aria-hidden="true"></i>
              熬夜党专属
            </span>
            <h2 className="mt-4 font-display text-3xl text-background-50 md:text-4xl">
              熬夜补番清单
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-50/85 md:text-base">
              剧情紧凑到让人停不下来的上头之作，一旦点开就可能看到天亮。
              备好零食、调暗灯光，一起把「再看一集就睡」变成现实吧。
            </p>
            <button
              type="button"
              onClick={() => navigate("/list/allnight")}
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-movie-2-line" aria-hidden="true"></i>
              打开熬夜清单
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeader
          eyebrow="停不下来"
          title="熬夜补番精选"
          desc="节奏飞快、反转不断的高能之作，从今天熬夜清单里的几部开始。"
          linkText="看全部熬夜番"
          linkTo="/list/allnight"
        />
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4 md:gap-5">
          {getByCategory("allnight")
            .slice(0, 4)
            .map((anime) => (
              <AnimeCard key={anime.id} anime={anime} />
            ))}
        </div>
      </section>
    </>
  );
}